import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSimulador } from '../../context/SimuladorContext';
import GestorLayout from '../../components/GestorLayout';

export default function SimuladorOperadores() {
  const navigate = useNavigate();
  const { abrirSimulador } = useSimulador();

  useEffect(() => {
    // Abre o simulador flutuante e redireciona para o dashboard
    abrirSimulador();
    navigate('/gestor/dashboard', { replace: true });
  }, [abrirSimulador, navigate]);

  return (
    <GestorLayout>
      <div className="flex items-center justify-center h-64">
        <p className="text-stone-500">A abrir simulador...</p>
      </div>
    </GestorLayout>
  );
}
